const roadMapData = [
    {
        year: "2021",
        range: "August",
        content: "Presale ICO.",
        status: "running"
    },
    {
        year: "2021",
        range: "December",
        content: "Listing on JustSwap.",
        status: "pending"
    },
    {
        year: "2022",
        range: "January",
        content: "Charry swap launch for sale or exchange charry.",
        status: "pending"
    },
    {
        year: "2022",
        range: "February",
        content: "Charry Swap with more coins.",
        status: "pending"
    },
    {
        year: "2022",
        range: "March",
        content: "Launch Charry lending service.",
        status: "pending"
    },
    {
        year: "2022",
        range: "April",
        content: "Listing on exchanges for trade.",
        status: "pending"
    }
];

export default roadMapData;